import React, { useState, useEffect } from 'react';
import  './Header.css';

export default function Header({ onOpenDrawer, onNavigate, user, onLogout }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 15);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const displayName = user?.displayName || "Student";
  const email = user?.email || "";
  const avatarUrl = user?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=f1f5f9&color=0f172a`;

  return (
    <header className={`academic-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="academic-nav-container">
        
        {/* Mobile Menu Button */}
        <button className="academic-menu-btn" onClick={onOpenDrawer} aria-label="Open Menu">
          <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>

        {/* Academic Brand & Icon */}
        <div className="academic-brand" onClick={() => onNavigate('folders')}>
          <div className="brand-logo-container">
            <img src="/assets/icon.gif" alt="GangaTricks Logo" className="brand-logo-img" />
          </div>
          <div className="brand-titles">
            <span className="brand-name">GangaTricks</span>
          </div>
        </div>

        {/* Center Navigation & Catalog Dropdown */}
        <nav className="academic-nav-menu">
          <button className="nav-link-btn" onClick={() => onNavigate('folders')}>
            Home
          </button>

          {/* Catalog / Subject Explorer */}
          <div 
            className="catalog-dropdown-wrapper"
            onMouseEnter={() => setActiveMenu('catalog')}
            onMouseLeave={() => setActiveMenu(null)}
          >
            <button className={`nav-link-btn catalog-trigger ${activeMenu === 'catalog' ? 'open' : ''}`}>
              <span>Course Catalog</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            </button>

            {/* Structured Academic Dropdown Menu */}
            <div className={`catalog-menu ${activeMenu === 'catalog' ? 'show' : ''}`}>
              <div className="catalog-grid">
                <div className="catalog-col">
                  <span className="catalog-heading">Quantitative & Math</span>
                  <a href="/Subject-Wise/Mathematics" className="catalog-item">
                    <strong>Mathematics</strong>
                    <span>Arithmetic, Algebra & Advanced Quants</span>
                  </a>
                  <a href="/Subject-Wise/Reasoning" className="catalog-item">
                    <strong>Logical Reasoning</strong>
                    <span>Verbal & Non-Verbal Analytical Reasoning</span>
                  </a>
                </div>

                <div className="catalog-col">
                  <span className="catalog-heading">Language & General Studies</span>
                  <a href="/Subject-Wise/English" className="catalog-item">
                    <strong>English Language</strong>
                    <span>Grammar, Vocabulary & Comprehension</span>
                  </a>
                  <a href="/Subject-Wise/Awareness" className="catalog-item">
                    <strong>General Awareness</strong>
                    <span>Current Affairs, Statics & Banking</span>
                  </a>
                </div>

                <div className="catalog-col catalog-promo-col">
                  <div className="catalog-promo-card">
                    <span className="promo-tag">FAST-TRACK REVISION</span>
                    <h4>GangaPathshala Crux Notes</h4>
                    <p>Concise summary sheets designed for rapid pre-exam review.</p>
                    <a href="/Subject-Wise/Crux" className="promo-btn">Explore Notes &rarr;</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button className="nav-link-btn" onClick={() => onNavigate('posts')}>
            All Modules
          </button>

          <button className="nav-link-btn" onClick={() => onNavigate('contact')}>
            Support & Contact
          </button>
        </nav>

        {/* Right Side: Widgets */}
        <div className="academic-actions">
          
          {/* Active Learning Track Pill with Hover Dropdown */}
          <div 
            className="track-widget-wrapper"
            onMouseEnter={() => setActiveMenu('track')}
            onMouseLeave={() => setActiveMenu(null)}
          >
            <div className="learning-track-pill">
              <span className="track-pulse"></span>
              <div className="track-info">
                <span className="track-label">ACTIVE TRACK</span>
                <span className="track-name">Banking & SSC Prep</span>
              </div>
            </div>
            
            {/* Live Track Dropdown Menu */}
            <div className={`widget-dropdown ${activeMenu === 'track' ? 'show' : ''}`}>
              <div className="widget-header">Current Module <span className="highlight-text">68%</span></div>
              <h4 className="widget-title">Quantitative Aptitude: Profit & Loss</h4>
              <div className="mini-progress-bar"><div className="mini-progress-fill" style={{width: '68%'}}></div></div>
              <button className="widget-action-btn" onClick={() => onNavigate('posts')}>Resume Learning</button>
            </div>
          </div>

          {/* Smart Library Search Bar */}
          <button 
            className="academic-search-bar"
            onClick={() => document.dispatchEvent(new KeyboardEvent('keydown', {'key': 'k', 'ctrlKey': true}))}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <span className="search-placeholder">Search catalog or topics...</span>
            <span className="search-shortcut">⌘K</span>
          </button>

          {/* Student Profile with Course Progress Ring (75%) */}
          <div 
            className="student-profile-widget"
            onMouseEnter={() => setActiveMenu('profile')}
            onMouseLeave={() => setActiveMenu(null)}
          >
            <div className="progress-ring-container">
              <svg className="progress-ring" width="44" height="44">
                <circle className="progress-ring-bg" stroke="#e2e8f0" strokeWidth="2.5" fill="transparent" r="18" cx="22" cy="22"/>
                {/* 113 is the circumference (2 * pi * 18). Offset 28 = 75% filled */}
                <circle className="progress-ring-fill" stroke="#2563eb" strokeWidth="2.5" strokeDasharray="113" strokeDashoffset="28" strokeLinecap="round" fill="transparent" r="18" cx="22" cy="22"/>
              </svg>
              {/* Dynamic User Avatar */}
              <img src={avatarUrl} alt={`${displayName}'s Profile`} className="profile-avatar" />
            </div>

            {/* Profile Dropdown */}
            <div className={`widget-dropdown profile-dropdown ${activeMenu === 'profile' ? 'show' : ''}`}>
               <div className="profile-header">
                 {/* Dynamic User Details */}
                 <strong>{displayName}</strong>
                 <span>{email}</span>
               </div>
               
               <div className="profile-links">
                 <a 
                   href="#profile" 
                   onClick={(e) => { e.preventDefault(); onNavigate('profile'); setActiveMenu(null); }}
                 >
                   My Profile
                 </a>
                 <a 
                   href="#settings" 
                   onClick={(e) => { e.preventDefault(); onNavigate('settings'); setActiveMenu(null); }}
                 >
                   Account Settings
                 </a>
                 <a 
                   onClick={(e) => { e.preventDefault(); onLogout(); }} 
                   href="#logout" 
                   className="text-danger"
                 >
                   Sign Out
                 </a>
               </div>
               
            </div>
          </div>

        </div>
      </div>
    </header>
  );
}